import db from './indexedDb.js';
import data from './data.js';

const numOfDigits = 5;
const numOfProblems = 10;

const generateCluster = async () => {
    const userId = await getActiveUserId();
    const problems = data(numOfDigits, numOfProblems);
    await db.clusters.add({ userId, dateCreated: Date(), done: 0, numOfProblems });
    const cluster = await db.clusters.orderBy('id').last();
    problems.forEach(async (problem, index) => {
        await db.problems.add({ ...problem, clusterId: cluster.id, userId: userId });
    });

    return cluster;
}

const fetchCluster = async () => {
    const cluster = await generateCluster();
    const problems = await db.problems
        .where('clusterId').equals(cluster.id)
        .toArray();

    return { ...cluster, problems };
}

const setSolvedExp = async (id) => {
    await db.problems
        .update(id, { solvedExp: 1 });
}

const setSolvedStand = async (id) => {
    await db.problems
        .update(id, { solvedStand: 1 });
}

const calcuateStats = async (id) => {
    const expSolved = await db.problems
        .where({ clusterId: id, solvedExp: 1 })
        .count();
    const standardSolved = await db.problems
        .where({ clusterId: id, solvedStand: 1 })
        .count();
    const solved = await db.problems
        .where({ clusterId: id, solvedExp: 1, solvedStand: 1 })
        .count();
    return { expSolved, standardSolved, solved };
}

const calculateFullStats = async (userId) => {
    const exp = await db.problems
        .where({ userId, solvedExp: 1 })
        .count();
    const standard = await db.problems
        .where({ userId, solvedStand: 1 })
        .count();
    const full = await db.problems
        .where({ userId, solvedExp: 1, solvedStand: 1 })
        .count();
    const all = await db.problems
        .where({ userId })
        .count();
    return { exp, standard, full, all };
}

const finishCluster = async (id) => {
    const stats = await calcuateStats(id);
    await db.clusters
        .update(id, { ...stats, done: 1 });

    const userId = await getActiveUserId();
    const fullStats = await calculateFullStats(userId);
    await db.users
        .update(userId, { stats: fullStats });
}

// Stats
const fetchStats = async () => {
    const userId = await getActiveUserId();
    const stats = await db.clusters
        .where({ userId, done: 1 })
        .toArray();

    return stats;
}

const deleteProblems = async (clusters) => {
    await db.transaction('rw', db.clusters, db.problems, async ()=>{
        await clusters.each(async (cluster) => {
            await db.problems.where('clusterId').equals(cluster.id).delete();
        });
    });
}

const deleteUndone = async () => {
    const undoneClusters = await db.clusters.where('done').equals(0);
    await deleteProblems(undoneClusters);
    await undoneClusters.delete();
}

// function recreateDB(db) {
//     return db.delete().then (()=>db.open());
// }

const deleteData = async () => {
    const userId = await getActiveUserId();
    const userClusters = await db.clusters.where('userId').equals(userId);
    await deleteProblems(userClusters);
    await userClusters.delete();
}

// Auth
const logIn = async (pin) => {
    await logOutAnyActiveUser();
    let user = await getUser(pin);
    if (user === undefined) {
        await createUser(pin);
    } else {
        await activateUser(user);
    }
}

const logOut = async () => {
    await logOutAnyActiveUser();
}

const createUser = async (pin) => {
    await db.users.add({ pin, dateCreated: Date(), active: 1 });
    const user = await getUser(pin);
    const fullStats = await calculateFullStats(user.id);
    await db.users
        .update(user.id, { stats: fullStats });
}

const logOutAnyActiveUser = async () => {
    const user = await getActiveUser();
    if (user !== undefined) {
        await db.users.update(user.id, {active: 0});
    }
}

const activateUser = async (user) => {
    await db.users.update(user.id, {active: 1});
}

const getUser = async (pin) => await db.users.get({ pin });

const getActiveUser = async () => await db.users.get({active: 1});

const getActiveUserId = async () => {
    const { id: userId } = await getActiveUser() || { id: 0 };
    return userId;
}

export { fetchCluster, setSolvedExp, setSolvedStand, finishCluster, fetchStats, deleteUndone, deleteData, logIn, logOut, getActiveUser };
// export default fetchCluster;
